import { Button } from '@cokitchen/cokitchen-components';
import React, { useState } from 'react';
import {
  formatCurrency,
  formatMealsToBulkMealFormat,
  getAssignedUsers,
  getFullName,
  getOrderStatus
} from 'utils/functions';
import { ReactComponent as QuestionAltIcon } from 'assets/icons/question-alt-icon.svg';
import useDashboardContext from 'contexts/dashboard.context';
import { ReactComponent as Line2 } from 'assets/icons/Line2.svg';
import moment from 'moment';
import { LocationIcon, Users2Icon } from 'cokitchen-icons';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-back.svg';
import { ReactComponent as Scooter } from 'assets/icons/scooter.svg';
import { ReactComponent as NoteIcon } from 'assets/icons/note.svg';
import { ReactComponent as QuestionIcon } from 'assets/icons/question-icon-filled.svg';
import GroupOrderMealAccordion from 'components/meal-accordion/group-order-meal-accordion';
import useOrdersContext from 'contexts/orders.context';
import { Link } from 'react-router-dom';
import RateRiderModal from 'components/modals/rate-rider-modal';
import RateServiceModal from 'components/modals/rate-service-modal';
import TrackOrder from 'components/track-order';

import { ENUM_ORDER_PROGRESS } from 'utils/enum';
import ComplaintModal from 'components/modals/complaint-log-modal';
import { OrderObjectType, OrderType } from 'models/order.model';

type Props = {
  order: OrderType;
};
const CompletedOrder = ({ order }: Props) => {
  const { cokitchenList } = useDashboardContext();
  const { setcalculatedOrderForm, setBulkOrderMeals, setCoordinates } = useOrdersContext();
  const [showGetHelpModal, setShowGetHelpModal] = useState(false);
  const [showTimelineModal, setShowTimelineModal] = useState(false);
  const [showRateRiderModal, setShowRateRiderModal] = useState(false);
  const [showRateServiceModal, setShowRateServiceModal] = useState(false);
  const orderCokitchen = cokitchenList.find(
    (cokitchen) => cokitchen.id === order?.calculated_order.cokitchen_id
  );
  const subtTotal =
    Number(order?.calculated_order.total_amount) -
    Number(order?.calculated_order.delivery_fee) -
    Number(order?.calculated_order.service_charge);

  const creatCalculatedOrder: OrderObjectType = {
    cokitchen_polygon_id: order.calculated_order.cokitchen_polygon_id,
    address_details: order.calculated_order.address_details,
    discount_code: '',
    lat: order.calculated_order.lat,
    lng: order.calculated_order.lng,
    pickup: order.calculated_order.pickup,
    meals: [],
    recurring: order.calculated_order.recurring ?? false,
    scheduled_delivery_date: order.calculated_order.scheduled_delivery_date?.split('T')[0] ?? '',
    scheduled_delivery_time: order.scheduled_delivery_time ?? '',
    selected_days: order.calculated_order.selected_days,
    recurrence: order.calculated_order.recurrence ?? '',
    scheduled: order.calculated_order.scheduled,
    recurring_order_end_date:
      order.calculated_order.recurring_order_end_date?.split('T')[0] ?? '' ?? ''
  };

  const handleReorder = () => {
    const bulkMeals = formatMealsToBulkMealFormat(order.calculated_order.meals);
    setBulkOrderMeals(bulkMeals);
    setcalculatedOrderForm(creatCalculatedOrder);
    setCoordinates({ lat: order.calculated_order.lat, lng: order.calculated_order.lng });
  };
  const openTimelineModal = () => {
    setShowTimelineModal(!showTimelineModal);
  };
  const isOrderBulk =
    !order.calculated_order.is_company_group_order && !order.calculated_order.is_group_order;

  return (
    <div className='w-full'>
      <div className='flex items-center justify-between flex-wrap gap-3 mb-6'>
        <div className='flex items-center gap-2'>
          <p className='text-gray-10 text-2xl font-semibold'>Order #{order?.order_code}</p>
          <div
            className={`h-[22px] flex items-center justify-center gap-1 px-2 rounded-[40px] bg-[#E5F9E2]`}>
            <div className={`w-2 h-2 rounded-full bg-[#3FB827]`} />
            <p className={`text-xs font-medium capitalize text-[#3FB827]`}>
              {getOrderStatus(order)}
            </p>
          </div>
        </div>
        <div className='flex items-center flex-wrap gap-4'>
          <Button
            variant='block'
            color='gray'
            className='w-fit h-[40px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-gray-10 gap-3'
            onClick={() => setShowGetHelpModal(true)}>
            <QuestionAltIcon />
            <p>Get Help</p>
          </Button>
          {isOrderBulk && (
            <Link to='/orders/basket/bulk' onClick={handleReorder}>
              <Button variant='block' color='primary' className='w-fit h-[40px]'>
                Reorder Meal
              </Button>
            </Link>
          )}
        </div>
      </div>
      <div className='bg-[#F7F7F8] w-full lg:h-[80vh] rounded-xl p-1 flex flex-col-reverse lg:flex-row gap-2 lg:gap-6 lg:justify-between basket'>
        <div className='w-full lg:w-[48.5%] h-full relative'>
          <div className='w-full bg-white pt-7 px-6 pb-4 rounded-tl-lg mb-3'>
            <div className='w-full flex justify-between items-center mb-6'>
              <p className='text-xl text-gray-6 font-semibold'>Delivery details</p>
              <div className='bg-[#FEF0F2] py-[2px] px-2 rounded-[40px]'>
                <p
                  className='text-red-5 text-xs font-medium cursor-pointer'
                  onClick={() => setShowRateServiceModal(true)}>
                  Rate Service
                </p>
              </div>
            </div>
            <div className='w-full flex justify-between mb-8 relative'>
              <Line2 className='absolute bottom-[-85%] left-1.5' />
              <div className='flex gap-2'>
                <div className='w-[14px] h-[14px] rounded-full bg-white border-[1.5px] border-[#F73B58]  mt-1' />
                <div>
                  <p className='text-gray-6 text-sm'>{orderCokitchen?.name}</p>
                  <p className='text-[#6F7376] text-sm'>
                    {moment(order?.kitchen_accepted_time).format('hh:mm a')}
                  </p>
                </div>
              </div>
              <p className='text-[#6F7376] text-sm'>
                {moment(order?.kitchen_accepted_time).format('ddd, Do MMM YYYY')}
              </p>
            </div>
            <div className='w-full flex justify-between mb-8'>
              <div className='flex gap-2  text-red-5 w-[60%]'>
                <LocationIcon className='mt-1' />
                <div className='w-[90%]'>
                  <p className='text-gray-6 text-sm line-clamp-1'>
                    {order.calculated_order.address_details.address_line}
                  </p>
                  <p className='text-[#6F7376] text-sm'>
                    {moment(order?.completed_time).format('hh:mm a')}
                  </p>
                </div>
              </div>
              <p className='text-[#3FB827] text-sm'>Completed</p>
            </div>
            <div
              className='text-red-5 text-sm flex gap-1 items-center cursor-pointer'
              onClick={openTimelineModal}>
              <p>View order timeline</p>
              <ArrowRightIcon
                className='
              transform rotate-180'
              />
            </div>
          </div>
          <div className='w-full bg-white pt-7 px-6 pb-4 mb-3'>
            <div className='w-full flex justify-between mb-4'>
              <div className='flex gap-2'>
                <Scooter />
                <div>
                  <p className='text-gray-6 text-sm font-medium'>
                    {getFullName({
                      first_name: order?.user?.first_name,
                      last_name: order?.user?.last_name
                    })}
                  </p>
                  <p className='text-[#96999C] text-xs'>Dispatch</p>
                </div>
              </div>
              <div
                className='text-red-5 text-sm font-medium cursor-pointer'
                onClick={() => setShowRateRiderModal(true)}>
                Rate rider
              </div>
            </div>
            <div className='w-full flex gap-3 items-center'>
              <NoteIcon />
              <p className='text-[#96999C] text-sm'>{order.order_details.rider_note}</p>
            </div>
          </div>
          <div className='w-full rounded-bl-lg bg-white px-6 pt-6 pb-10'>
            <div className='flex justify-between mb-3'>
              <p className='text-[#6F7376] text-sm'>Subtotal</p>
              <p className='text-[#6F7376] text-sm font-medium'>{formatCurrency(subtTotal)}</p>
            </div>
            <div className='flex justify-between mb-3'>
              <p className='text-[#6F7376] text-sm'>Delivery fee</p>
              <p className='text-[#6F7376] text-sm font-medium'>
                {formatCurrency(order.calculated_order.delivery_fee)}
              </p>
            </div>
            <div className='flex justify-between mb-3 pb-4 border-b-[1px] border-b-[#EAEBEB]'>
              <div className='flex gap-1 items-center'>
                <p className='text-[#6F7376] text-sm'>Service fee</p>
                <QuestionIcon className='question-icon' />
              </div>
              <p className='text-[#6F7376] text-sm font-medium'>
                {formatCurrency(order.calculated_order.service_charge)}
              </p>
            </div>
            <div className='flex justify-between mb-3'>
              <p className='text-[#6F7376] text-sm'>Order total</p>
              <p className='text-[#6F7376] text-sm font-medium'>
                {formatCurrency(order.calculated_order.total_amount)}
              </p>
            </div>
          </div>
        </div>
        <div className='w-full lg:w-[48.5%] h-full bg-white'>
          <div className='w-full bg-white pt-7 px-6 pb-4 rounded-tr-lg mb-3'>
            <p className='text-xl text-gray-6 font-semibold mb-6'>Order details</p>
            <div className='w-full flex flex-col space-y-4'>
              {order.calculated_order.is_company_group_order &&
              order.calculated_order.is_group_order
                ? order.calculated_order.sub_calculated_order_ids?.map((meal, index) => (
                    <GroupOrderMealAccordion key={index} meal={meal} />
                  ))
                : order.calculated_order?.meals.map((meal, index) => (
                    <div key={index}>
                      <div className='pb-2 border-b-[1px] border-b-[#EAEBEB]'>
                        <h3 className='font-semibold text-gray-6 mb-1'>{meal.brand?.name}</h3>
                      </div>
                      <div className='w-full pt-2'>
                        <ul className='last:rounded-br-lg'>
                          {meal.meals.map((mealItem, index) => (
                            <li
                              className={`py-4 px-[18px] 
              
              ${index === meal.meals.length - 1 ? '' : 'border-b-[1px] border-b-[#EAEBEB]'}
              
              `}
                              key={index}>
                              <div className='w-full flex items-center gap-4 mb-1'>
                                <p className='text-sm text-red-5 font-medium'>
                                  {mealItem.quantity}x
                                </p>

                                <article className='flex flex-col gap-[3px]'>
                                  <p className='text-sm font-medium leading-[21px]'>
                                    {mealItem.name}
                                  </p>
                                  <ul>
                                    {mealItem.addons?.map((addon) => (
                                      <li
                                        key={addon.id}
                                        className='text-sm text-[#6F7376] leading-[22.4px]'>
                                        {addon.quantity}x&nbsp;{addon?.meal_data?.name}
                                      </li>
                                    ))}
                                  </ul>
                                </article>

                                <div className='flex items-center gap-[10px] font-medium ml-auto'>
                                  <p>{formatCurrency(meal.amount)}</p>
                                </div>
                              </div>
                              {mealItem.members?.length ? (
                                <div className='w-full bg-[#F5F5F5] rounded-[6px] py-[8.5px] px-[11px] text-[#5E6164] flex gap-1'>
                                  <Users2Icon />
                                  <p>{getAssignedUsers(mealItem)}</p>
                                </div>
                              ) : null}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ))}
            </div>
          </div>
        </div>
      </div>
      <TrackOrder
        title={ENUM_ORDER_PROGRESS.ORDER_COMPLETED}
        order={order}
        showModal={showTimelineModal}
        onClose={openTimelineModal}
      />

      <RateRiderModal
        show={showRateRiderModal}
        onClose={() => setShowRateRiderModal(false)}
        order={order}
      />
      <RateServiceModal
        show={showRateServiceModal}
        onClose={() => setShowRateServiceModal(false)}
        order={order}
      />
      <ComplaintModal show={showGetHelpModal} onClose={() => setShowGetHelpModal(false)} />
    </div>
  );
};

export default CompletedOrder;
